import React from 'react';
import {
  notification,
  show_notification
} from './TopHeaderForNotification.module.css';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { isLoggedIn } from '../../utils/cookie-utils';
const TopHeaderForNotification = ({
  showNotificationHeader,
  setShowNotificationHeader,
  message
}) => {
  if (!isLoggedIn() && location.pathname !== `/`) return null;

  return (
    <div
      className={` ${
        showNotificationHeader ? show_notification : 'hidden'
      } ${notification}
       w-full bg-black-0   mb-1 text-sm px-2 text-sm py-5 text-sm text-white  top-0 relative shadow-md `}
    >
      <span className="mr-2">
        {message ||
          'Notification service is not enabled! Enable the service to recieve the notifications'}
      </span>
      <div className="table float-right mr-0 ml-auto ">
        <CloseIcon
          className="cursor-pointer"
          onClick={() => setShowNotificationHeader(false)}
        />
      </div>
    </div>
  );
};

export default TopHeaderForNotification;
